import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Starter from "./views/Starter.vue";
import Domain from "./views/domains/index.vue";
import Subscriber from "./views/subscribers/index.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        header: AppHeader,
        default: Starter
      }
    },
    {
      path: "/domains",
      name: "domains",
      components: {
        header: AppHeader,
        default: Domain
      }
    },
    {
      path: "/subscribers",
      name: "subscribers",
      components: {
        header: AppHeader,
        default: Subscriber
      }
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
